import { GLOBAL } from 'saddlebag-browser';

import { STREVDA_CONTAINERS } from '../../constants';

export interface StrevdaRuntimeAdvertsParameters {
  SIDEBAR_CONTAINER?: string;
  LEADERBOARD_CONTAINER?: string;
  MOBILE_CONTAINER?: string;
  [key: string]: string | undefined;
}

export interface StrevdaRuntimeProps {
  advertsParameters?: StrevdaRuntimeAdvertsParameters;
  [key: string]: unknown;
}

export interface StrevdaContainer {
  type?: string;
  targetElementId: string;
}

export interface StrevdaAdverts {
  enabled?: boolean;
  strevdaRuntimeProps?: StrevdaRuntimeProps;
}

export interface StrevdaProps {
  enabled: boolean | undefined;
  strevdaRuntimeProps: StrevdaRuntimeProps;
  containers: StrevdaContainer[];
}

const defaultAdverts: StrevdaAdverts & {
  enabled: boolean;
  strevdaRuntimeProps: StrevdaRuntimeProps;
} = {
  enabled: false,
  strevdaRuntimeProps: {},
};

export const getProps = (): StrevdaProps => {
  const $window = GLOBAL.getWindow();
  const { adverts = defaultAdverts } = $window.__internal;
  delete $window.__internal.adverts;

  const { enabled } = adverts;
  const strevdaRuntimeProps: StrevdaRuntimeProps =
    adverts.strevdaRuntimeProps ?? {};
  const advertsParameters: StrevdaRuntimeAdvertsParameters =
    strevdaRuntimeProps.advertsParameters ?? {};

  const containers: StrevdaContainer[] = [
    {
      type: advertsParameters.SIDEBAR_CONTAINER,
      targetElementId: STREVDA_CONTAINERS.SIDEBAR,
    },
    {
      type: advertsParameters.LEADERBOARD_CONTAINER,
      targetElementId: STREVDA_CONTAINERS.BANNER,
    },
    {
      type: advertsParameters.MOBILE_CONTAINER,
      targetElementId: STREVDA_CONTAINERS.MOBILE_MPU,
    },
  ];

  return {
    enabled,
    strevdaRuntimeProps,
    containers,
  };
};
